import React from 'react';
import './About.scss';
import Hero from '../../contains/Hero/Hero';
import Story from '../../components/about-components/Story';
import aboutImage from '../../assets/img/aboutImage.webp';
import {Helmet, HelmetProvider } from 'react-helmet-async';
import OgImage from "../../assets/img/Og.png";

function About({t,handlerSelectModal}) {
  const aboutData = {
    capture:t("about_capture"),
    text:t("about_description"),
    img:aboutImage,
    altImage:t("ali_og_about")
  }
  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("about_og_title")}</title>
        <meta name="description" content={t("about_og_description")}></meta>
        <meta property="og:title" content={t("about_og_title")} />
        <meta property="og:description" content={t("about_og_description")} />
        <meta property="og:image" content={OgImage} />
        <link rel="canonical" href="https://weexpert.io/" />
      </Helmet>
    <Hero t={t} data = {aboutData} handlerSelectModal={handlerSelectModal}/>
    <Story t={t}/>
    </HelmetProvider>
  );
}

export default About;